export default "/images/b744b311a26972fb472c9da71eb1b38f.avif";